import {amber,blue,blueGrey,brown,cyan,deepOrange,deepPurple,green,indigo,lightBlue,lightGreen,lime,orange,pink,purple,red,teal,yellow} from '@material-ui/core/colors'
import { AocClasses } from '@pvplevelup/core/dist/interfaces/ICharacter'
export const TeamColors = [
  blue[600],
  red[700],
  yellow[800],
  deepPurple[500],
  blueGrey[500],
  brown[500],
  cyan[800],
  deepOrange[800],
  green[600],
  indigo[500],
  lightBlue[500],
  lime[300],
  orange[800],
  pink[500],
  purple[500],
  teal[500],
  lightGreen[500]
]

export const TeamColorsOpacity = [
  "34, 48, 191",
  "219, 26, 28",
  "34, 48, 191",
  "219, 26, 28",
  "249, 168, 37",
  "103, 58, 183",
  "96, 125, 139",
  "121, 85, 72",
  "0, 188, 212",
  "255, 87, 34",
  "76, 175, 80",
  "63, 81, 181",
  "3, 169, 244",
  "255, 193, 7"
]

export const ClassColorsObject = {
  [AocClasses.Assassin]: "#b97ce1",
  [AocClasses.Barbarian]: "#876914",
  [AocClasses.Ranger]: "#55843e",
  [AocClasses.PriestofMitra]: "#ffee59",
  [AocClasses.BearShaman]: "#89cb74",
  [AocClasses.TempestofSet]: "#65b0d3",
  [AocClasses.Demonologist]: "#b3382f",
  [AocClasses.Necromancer]: "#715184",
  [AocClasses.HeraldofXotli]: "#de5956",
  [AocClasses.Guardian]: "#c7c6c4",
  [AocClasses.DarkTemplar]: "#626569",
  [AocClasses.Conqueror]: "#bb9e4e",
  ["NotClass"]: "#ffeaae"
}

export const ClassColors = (charClass: AocClasses) => {
  switch(charClass){
    case AocClasses.Assassin:
      return ClassColorsObject[AocClasses.Assassin];
    case AocClasses.Barbarian:
      return ClassColorsObject[AocClasses.Barbarian];
    case AocClasses.Ranger:
      return ClassColorsObject[AocClasses.Ranger];
    case AocClasses.PriestofMitra:
      return ClassColorsObject[AocClasses.PriestofMitra];
    case AocClasses.BearShaman:
      return ClassColorsObject[AocClasses.BearShaman];
    case AocClasses.TempestofSet:
      return ClassColorsObject[AocClasses.TempestofSet];
    case AocClasses.Demonologist:
      return ClassColorsObject[AocClasses.Demonologist];
    case AocClasses.Necromancer:
      return ClassColorsObject[AocClasses.Necromancer];
    case AocClasses.HeraldofXotli:
      return ClassColorsObject[AocClasses.HeraldofXotli];
    case AocClasses.Guardian:
      return ClassColorsObject[AocClasses.Guardian];
    case AocClasses.DarkTemplar:
      return ClassColorsObject[AocClasses.DarkTemplar];
    case AocClasses.Conqueror:
      return ClassColorsObject[AocClasses.Conqueror];
    default:
      return ClassColorsObject["NotClass"];
  }
}

export const ClassTextColors = (charClass: AocClasses) => {
  switch(charClass){
    case AocClasses.Assassin:
      return "#ffffff";
    case AocClasses.Barbarian:
      return "#ffffff";
    case AocClasses.Ranger:
      return "#ffffff";
    case AocClasses.PriestofMitra:
      return "#242424";
    case AocClasses.BearShaman:
      return "#242424";
    case AocClasses.TempestofSet:
      return "#242424";
    case AocClasses.Demonologist:
      return "#ffffff";
    case AocClasses.Necromancer:
      return "#ffffff";
    case AocClasses.HeraldofXotli:
      return "#ffffff";
    case AocClasses.Guardian:
      return "#242424";
    case AocClasses.DarkTemplar:
      return "#ffffff";
    case AocClasses.Conqueror:
      return "#ffffff";
    default:
      return "#ffffff";
  }
}


export const ClassColorsAll = [
  purple[800],
  brown[500],
  green[700],
  yellow[600],
  orange[800],
  blue[700],
  red[400],
  deepPurple[400],
  red[900],
  blueGrey[400],
  deepPurple[800],
  deepOrange[300],
  amber[600]
]